/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_CtaInputs */

const en_visa_eb5_cta = /** @type {(inputs: Visa_Eb5_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start your EB-5 investment journey`)
};

const pt_visa_eb5_cta = /** @type {(inputs: Visa_Eb5_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece sua jornada de investimento EB-5`)
};

const es_visa_eb5_cta = /** @type {(inputs: Visa_Eb5_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comience su viaje de inversión EB-5`)
};

/**
* | output |
* | --- |
* | "Start your EB-5 investment journey" |
*
* @param {Visa_Eb5_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_cta = /** @type {((inputs?: Visa_Eb5_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_cta(inputs)
	if (locale === "es") return es_visa_eb5_cta(inputs)
	return en_visa_eb5_cta(inputs)
});